import React from "react"

export default function CurveTSm(props) {
  return (
    <svg
      viewBox="0 0 1512 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 9.475s389.488-21.319 756 0c366.51 21.306 756 0 756 0V37H0V9.475z"
        fill="currentColor"
      />
    </svg>
  )
}
